// 车辆维保申请申请
const vehicleMaintenanceApplyDlg = {
  namespaced: true,

  state: {
    dlgShow: false,
  },

  getters: {
    dlgShow: state => state.dlgShow,
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },
  },

  actions: {

  }
}

export default vehicleMaintenanceApplyDlg
